import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import UpdatePopUp from "../AjeerUpdate/UpdatePopUp";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import { useEffect } from "react";
import nodeinstance from "../../../../../nodeInstance";
import RemovePopUp from "./RemovepopUp";

export default function ListAjeerRenewal({
  token,
  titles = [],
  listView = [],
  updateData,
  selectedStatus,
  setSelectedStatus,
  selectVisaProvider,
  setSelectVisaProvider,
  setResponseData,
  setShowData,
  setApiKey,
  Apikey,
  setTrigger,
  trigger,
}) {
  console.log("filteredData......", listView);
  // const [listView, setList] = useState([]);

  // useEffect(() => {
  //   setList(list);
  // }, [selectedStatus,selectVisaProvider]);
  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  const [Popup, setPopUp] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});

  const [listData, SetListData] = useState([]);

  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    const newCheckedItems = {};
    if (isChecked) {
      listView.forEach((item) => {
        newCheckedItems[item.employee_id] = true;
      });
    }
    setCheckedItems(newCheckedItems);
    SetListData(isChecked ? [...listView] : []);
  };

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;

    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true;
      } else {
        delete nextState[employee_id];
      }
      return nextState;
    });

    SetListData((prevItemList) => {
      const updatedList = Array.isArray(prevItemList)
        ? prevItemList.filter((item) => item !== list)
        : [];
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });

    // If any checkbox is unchecked, uncheck the "Select All" checkbox
    if (!isChecked) {
      setSelectAll(false);
    } else if (Object.keys(checkedItems).length + 1 === listView.length) {
      // If all checkboxes are checked, mark "Select All" as checked
      setSelectAll(true);
    }
  };

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectAll(false);
    SetListData([]);
    setCheckedItems({});
    setSelectedStatus(clientStatus);
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Client:", visaProvider);
    setSelectAll(false);
    SetListData([]);
    setCheckedItems({});
    setSelectVisaProvider(visaProvider);
  };

  const onSearchClick = async () => {
    try {
      const response = await nodeinstance.get(
        `/ajeer/searchEmployee/${Apikey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setResponseData(response.data.data);
        setShowData(true);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  const dispatch = useDispatch();
  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };

  const callBack = () => {
    updateData();
  };
  // console.log("currentList to be printed in the console", listView);

  const onSearchChange = (e) => {
    setApiKey(e.target.value);
  };
  const onClearResponse = (e) => {
    setResponseData([]);
  };
  const [open, setOpen] = useState(false);

  const handleRemoveClick = () => {
    // setOpen(true);
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => {
              handleRemoveClick();
            }}
          >
            <p>Remove</p>
          </button>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => popOpen()}
          >
            <p>Renew</p>
          </button>

          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => {
              onClearResponse();
            }}
          >
            <p>Clear filter</p>
          </button>

          <div style={styles.container}>
            <input
              type="text"
              placeholder="Enter text here"
              style={styles.input}
              value={Apikey}
              onChange={(e) => {
                onSearchChange(e);
              }}
            />
            <span
              style={styles.tickIcon}
              onClick={() => {
                onSearchClick();
              }}
            >
              ✔️
            </span>
          </div>
          <FilterDropDown
            onChange={visaProviderFilter}
            title={"Visa Provider"}
            url={`/sadaad/visa-providers/`}
            token={token}
            selectedStatus={selectVisaProvider}
          />
          <FilterDropDown
            onChange={onChangeValue}
            title={"Client"}
            url={`/sadaad/clients`}
            token={token}
            selectedStatus={selectedStatus}
          />
        </div>

        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        {/* <CountPerPage /> */}
        <div className="overflow-x-auto" style={{ backgroundColor: "white" }}>
          <table className="min-w-full divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                {titles.map((columnName, index) => (
                  <th
                    key={index}
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                  >
                    {columnName}
                  </th>
                ))}

                <th className="px-6 py-4">
                  {selectedStatus !== "" && selectVisaProvider !== "" ? (
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                    />
                  ) : (
                    ""
                  )}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-gray-10">
              {listView?.map((listItem, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.employee_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.sponsor}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.client_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.visa_provider}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.iqama_number}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.ajeer_location_eng}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.ajeer_location_ar}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.ajeer_apply_date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.ajeer_issue_date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem.ajeer_expiry_date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {listItem?.ajeer_valid_days}
                  </td>

                  {selectedStatus !== "" && selectVisaProvider !== "" ? (
                    <div className="flex items-center mb-0 ml-6 ">
                      <input
                        key={listItem.employee_id} // Use a unique identifier as the key
                        type="checkbox"
                        checked={checkedItems[listItem.employee_id] || false}
                        onChange={(event) =>
                          handleCheckboxChange(
                            event,
                            listItem.employee_id,
                            listItem
                          )
                        }
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                  {/* </React.Fragment> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <Pagination /> */}
      </div>
      {Popup ? (
        <UpdatePopUp
          list={listData}
          data={Popup}
          url={"/ajeer/renew"}
          setPopUp={setPopUp}
          callback={callBack}
        />
      ) : (
        ""
      )}
      {open ? (
        <RemovePopUp
          open={open}
          setOpen={setOpen}
          list={listData}
          setTrigger={setTrigger}
          trigger={trigger}
          setApiKey={setApiKey}
        />
      ) : (
        ""
      )}
    </>
  );
}
